import React from 'react';

type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  strokeWidth?: string;
};

/**
 * Arrow drawing tool (PLAT-11289). A diagonal shaft with a head — distinct from
 * the axis-aligned navigation arrows (`ArrowUpIcon`, `LongArrowDownIcon`, …),
 * which mean movement or direction rather than a mark to draw.
 */
const DrawArrowIcon = (props: Props) => {
  const {
    width = '16',
    height = '16',
    viewBox = '0 0 16 16',
    strokeColor = 'var(--text-secondary)',
    strokeWidth = '1.6',
  } = props;
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M2.5 13.5 13 3"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M7.75 3h5.5v5.5"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DrawArrowIcon;
